import gql from 'graphql-tag'
import { RemoveUserDataFromEventMutation, RemoveUserDataFromEventMutationVariables } from 'generated/graphql'
import graphql from 'utils/graphql'

const removeUserDataFromEventMutation = gql`
    mutation removeUserDataFromEvent($event: EventID!) {
        removeUserDataFromEvent(event: $event)
    }
`

export const removeUserDataFromEvent = (event: string | number) => {
    const query = graphql.createQuery<
        RemoveUserDataFromEventMutation,
        RemoveUserDataFromEventMutationVariables
    >(removeUserDataFromEventMutation)
    return query({ event })
}
